import React, { useEffect, useRef, useState } from 'react';
import Icon from '../../../components/AppIcon';

const METRICS = [
  { id: 1, icon: 'Banknote', label: 'Total winnings paid', target: 120, suffix: 'Cr+', prefix: '₹', color: '#25D366' },
  { id: 2, icon: 'Users', label: 'Verified winners', target: 2847, suffix: '', prefix: '', color: '#F0C24B' },
  { id: 3, icon: 'Timer', label: 'Average payout time', target: 5, suffix: ' min', prefix: '', color: '#5B8CFF' },
  { id: 4, icon: 'Heart', label: 'Customer satisfaction', target: 99.2, suffix: '%', prefix: '', color: '#FF3D71' },
];

const useCountUp = (target, run) => {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!run) return undefined;
    const duration = 1400;
    const start = performance.now();
    let frame;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - (1 - p) ** 3;
      setValue(target * eased);
      if (p < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, run]);
  return value;
};

const MetricTile = ({ metric, run }) => {
  const value = useCountUp(metric.target, run);
  const display = metric.target % 1 === 0 ? Math.round(value).toLocaleString('en-IN') : value.toFixed(1);

  return (
    <div className="stat-3d">
      <span
        className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10"
        style={{ background: `${metric.color}1F` }}
      >
        <Icon name={metric.icon} size={22} color={metric.color} />
      </span>
      <div className="font-display text-2xl font-bold text-white tabular-nums sm:text-3xl">
        {metric.prefix}
        {display}
        {metric.suffix}
      </div>
      <div className="mt-1 text-xs text-white/45">{metric.label}</div>
    </div>
  );
};

const SuccessMetricsSection = () => {
  const [run, setRun] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setRun(true),
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative overflow-hidden border-y border-white/8 bg-[#07070E]/70 py-16">
      <span className="aurora left-1/2 top-0 h-72 w-[34rem] -translate-x-1/2 bg-royal-gold/15" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="perspective grid grid-cols-2 gap-4 lg:grid-cols-4">
          {METRICS.map((m) => (
            <MetricTile key={m.id} metric={m} run={run} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessMetricsSection;
